import { defineStore } from 'pinia';

export const useOpenModalAsRoute = defineStore('routeModalStore', () => {
  const isModalVisible = ref(false);
  const modalHeader = ref('');

  const handleClose = () => {
    isModalVisible.value = false;
  };

  const showModal = () => {
    isModalVisible.value = true;
  };

  return {
    isModalVisible,
    handleClose,
    showModal,
    modalHeader,
  };
});
